import { login, logout, getUserInfo, refreshToken } from "@/api/auth";
import { getToken, setToken, removeToken } from "@/utils/auth";
import router from "@/router";
import { loginOut, loginToken } from "@/api/baseInfo";
const state = {
  token: getToken(),
  userInfo: null,
  isLoggedIn: false,
};

const mutations = {
  SET_TOKEN(state, token) {
    state.token = token;
    state.isLoggedIn = !!token;
  },
  SET_USER_INFO(state, userInfo) {
    state.userInfo = userInfo;
  },
  CLEAR_AUTH(state) {
    state.token = null;
    state.userInfo = null;
    state.isLoggedIn = false;
  },
};

const actions = {
  // 登录
  async login({ commit }, loginData) {
    try {
      let response;

      // 检查是否是模拟数据（从登录页面传来的直接数据）
      if (loginData.data && loginData.data.token) {
        // 模拟登录数据
        response = loginData;
      } else {
        // 真实API调用
        response = await login(loginData);
      }

      const { token, userInfo } = response.data;

      commit("SET_TOKEN", token);
      commit("SET_USER_INFO", userInfo);
      setToken(token);

      // 同时存储到localStorage
      localStorage.setItem("sanxiang_user", JSON.stringify(userInfo));

      return response;
    } catch (error) {
      throw error;
    }
  },

  // 获取用户信息
  async getUserInfo({ commit }) {
    try {
      const response = await getUserInfo();
      const userInfo = response.data;
      commit("SET_USER_INFO", userInfo);
      return userInfo;
    } catch (error) {
      throw error;
    }
  },

  async loginTokenFun({ state, dispatch, commit }) {
    loginToken({
      token: `Bearer ${localStorage.getItem("token")}`,
      source: "R",
    }).then((res) => {
      if (res.code == 1) {
        localStorage.setItem("token", res.datas.token);
        localStorage.setItem(
          "tenantId",
          res.datas.loginTenantDTOS
            ? res.datas.loginTenantDTOS.find((item) => item.nowTenant === "Y")
                .tenantId
            : ""
        );
        localStorage.setItem("phone", res.datas.phone);
        localStorage.setItem("userName", res.datas.userName);
        // this.$message.success("登录成功，正在跳转...");
        this.$store.dispatch("auth/login", {
          data: { token: res.datas.token, userInfo: res.datas },
        });
      } else if (res.code == "1002") {
        this.isLoggedIn = false;
        localStorage.clear();
        removeToken();
      }
    });
  },

  // 退出登录
  async logout({ commit }) {
    try {
      // await logout()
      loginOut({
        tenantId: localStorage.getItem("tenantId"),
        loginName: localStorage.getItem("phone"),
      }).then((res) => {
        this.isLoggedIn = false;
        localStorage.clear();
        window.location.reload();
        this.$message.success(res.msg);
      });
    } catch (error) {
      console.error("退出登录失败:", error);
    } finally {
      commit("CLEAR_AUTH");
      removeToken();
      router.push("/home");
    }
  },

  // 刷新Token
  async refreshToken({ commit }) {
    try {
      const response = await refreshToken();
      const { token } = response.data;
      commit("SET_TOKEN", token);
      setToken(token);
      return token;
    } catch (error) {
      // 刷新失败，清除登录信息
      commit("CLEAR_AUTH");
      removeToken();
      router.push("/login");
      throw error;
    }
  },

  // 初始化认证状态
  async initAuth({ commit }) {
    const token = getToken();
    const userInfoStr = localStorage.getItem("sanxiang_user");

    if (token && userInfoStr) {
      commit("SET_TOKEN", token);
      try {
        const userInfo = JSON.parse(userInfoStr);
        commit("SET_USER_INFO", userInfo);
      } catch (error) {
        // 用户信息解析失败，清除登录信息
        commit("CLEAR_AUTH");
        removeToken();
        localStorage.removeItem("sanxiang_user");
      }
    }
  },
};

const getters = {
  token: (state) => state.token,
  userInfo: (state) => state.userInfo,
  isLoggedIn: (state) => state.isLoggedIn,
  userType: (state) => state.userInfo?.userType,
  companyId: (state) => state.userInfo?.companyId,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
